module.exports = __webpack_public_path__ + "static/media/wood-container.fc6e7652.png";